import axios from '../api';
import { resolveMediaUrl } from './url';

export async function getTopWeeklyCreators(limit = 3) {
  const res = await axios.get(`/users/leaderboard/weekly/top3`);
  return (res.data.items || []).map(u => ({
    id: u.id,
    name: u.displayName || u.username,
    avatar: resolveMediaUrl(u.avatarUrl && u.avatarUrl.length > 0 ? u.avatarUrl : '/avatars/default-avatar.png'),
  }));
}
